export default __webpack_public_path__ + "fb448e0a6790375ac6658606ee922444.svg";